import { ec } from "@/common/db";
import { Shop } from "@/common/ec";
import { request } from "@umijs/max";
import { v4 as uuid } from "uuid";

export async function getShops() {
  const shops = await ec.query("shop");
  return shops;
}

export async function createShop(shop: Shop) {
  await ec.insert("shop", {
    id: uuid(),
    ...shop,
    productLoaded: false,
    orderLoaded: false,
    fundLoaded: false,
  } as Shop);
}

export async function deleteShop(shopId: string) {
  await ec.remove("shop", { id: shopId });
}

export type Entity = "product" | "order" | "fund";

export async function getEntities(entity: Entity, shopId: string) {
  const entities = await ec.query(entity as any, { 店铺编号: shopId });
  return entities;
}

export async function removeEntities(entity: Entity, shopId: string) {
  await ec.remove(entity as any, { 店铺编号: shopId });
  const targetShop: any = (await ec.query("shop", { id: shopId }))[0];
  if (targetShop) {
    targetShop[entity + "Loaded"] = false;
    ec.update("shop", targetShop, { id: shopId });
  }
}

export async function uploadEntities(entity: Entity, file: any) {
  const formData = new FormData();
  formData.append("file", file.originFileObj);
  return request("/api/ec/upload", {
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: formData,
  });
}

export async function saveEntities(
  entity: Entity,
  entities: any[],
  shopId: string
) {
  ec.insert(
    entity as any,
    entities.map((x: any) => ({ 店铺编号: shopId, ...x }))
  );
  const targetShop: any = (await ec.query("shop", { id: shopId }))[0];
  if (targetShop) {
    targetShop[entity + "Loaded"] = true;
    ec.update("shop", targetShop, { id: shopId });
  }
}
